import { render, staticRenderFns } from "./FaturasPagasModal.vue?vue&type=template&id=57be88b1&scoped=true"
import script from "./FaturasPagasModal.vue?vue&type=script&lang=js"
export * from "./FaturasPagasModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57be88b1",
  null
  
)

export default component.exports